import React from "react";
import profile from "../../assets/images/profile.jpeg";
import "./liveclass.css";

import { ReactComponent as Like } from "../../assets/images/like.svg";
import { ReactComponent as Heart } from "../../assets/images/heart.svg";
import { ReactComponent as Share } from "../../assets/images/share.svg";
import { ReactComponent as More } from "../../assets/images/more.svg";
import { ReactComponent as Avtar } from "../../assets/images/Avatar.svg";
import { ReactComponent as Select } from "../../assets/images/paperclip-2.svg";
import { ReactComponent as Send } from "../../assets/images/send.svg";
import ReactPlayer from "react-player";
import DiscussionItem from "../../components/DiscussionItem/DiscussionItem";

const LiveClass = () => {
  return (
    <div className="live_class p-40">
      <div className="row">
        <div className="col-md-8">
          <div className="left_side">
            <div className="player">
              <ReactPlayer
                url="https://www.w3schools.com/html/mov_bbb.mp4"
                light="https://plus.unsplash.com/premium_photo-1701090939615-1794bbac5c06?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                controls
                className="video_player"
              />
              <div className="tag">Live</div>
              <div className="live_user">2.5k</div>
            </div>
            <div className="course_heading">
              <h2>Drawing Fundamentals (Lesson 1)</h2>
              <ul>
                <li>
                  <Like />
                </li>
                <li>
                  <Heart />
                </li>
                <li>
                  <Share />
                </li>
              </ul>
            </div>
            <ul className="course_detail">
              <li className="course_review">
                Instructor: <span> Jane Cooper</span>
              </li>
              <li className="course_video">
                <i class="fas fa-user"></i> 2.531 watching
              </li>
            </ul>

            <div className="discussion">
              <h2>Discussion Group</h2>
              <div className="row">
                <div className="col-md-6">
                  <DiscussionItem />
                </div>
                <div className="col-md-6">
                  <DiscussionItem />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="right_side">
            <div className="course_content">
              <h2>Courses Content</h2>
              <ul>
                <li>
                  <h6>
                    <span>1</span>Basic Skills & Sketching Accurately
                  </h6>
                  <p>
                    Amet minim mollit non deserunt ullamco est sit aliqua dolor
                    do amet sint. Velit officia consequat duis.
                  </p>
                </li>
                <li>
                  <h6>
                    <span>2</span>Basic Skills & Sketching Accurately
                  </h6>
                  <p>
                    Amet minim mollit non deserunt ullamco est sit aliqua dolor
                    do amet sint. Velit officia consequat duis.
                  </p>
                </li>
              </ul>
            </div>
            <div className="live_chat">
              <div className="d-flex align-items-center justify-content-between">
                <h2>Live Chat</h2>
                <More />
              </div>
              <ul>
                <li>
                  <div className="img">
                    <Avtar />
                  </div>
                  <p>
                    <span>Savannah Nguyen</span>
                    That's simply extraordinary.
                  </p>
                </li>
                <li>
                  <div className="img">
                    <Avtar />
                  </div>
                  <p>
                    <span>Savannah Nguyen</span>
                    This imitation lessons are so awesome and it's really fun
                    when I try to copy your voice that time I feel over
                    confidence 😂 Thanks You so much for your interesting
                    videos.
                  </p>
                </li>
              </ul>

              <div className="send_message">
                <div className="select_item">
                  <Select />
                </div>
                <div className="message_input">
                  <input type="text" placeholder="Type Here...." />
                  <span>
                    <Send />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LiveClass;
